import { useMemo } from 'react';
import { useSandboxSession } from '../SandboxSessionContext';
import { useSandboxChanges } from '../../views/hooks/useOntologyViews';
import { buildBranchChangeMarkers } from '../utils/branchChangeMarkers';

export const useBranchChangeMarkers = () => {
  const { isPreviewActive, previewSandboxId, sandboxContext, previewSandboxHints } =
    useSandboxSession();
  const revisionId = sandboxContext?.active_overlay_id;
  const enabled = Boolean(isPreviewActive && previewSandboxId && revisionId);
  const query = useSandboxChanges({
    sandboxId: previewSandboxId,
    overlayId: revisionId || null,
    approvalId: previewSandboxHints?.approval_id || null,
    preferCommitted: true,
    enabled,
  });
  // Never show cached markers from another branch or revision while it resolves.
  const changes =
    enabled && !query.isError && query.data?.review?.revision_id === revisionId ? query.data : null;
  return useMemo(() => buildBranchChangeMarkers(changes), [changes]);
};
